<template>
  <layouts>
    <template #content>
      <zloading v-if="loading"></zloading>
      <div v-else class="bg-gray-200 h-auto">
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-start justify-between">
            <div>
              <h1 class="text-xl text-gray-800 font-medium mb-1">
                Ringkasan Omzet Domestik
              </h1>
              <h4 class="text-sm text-gray-500">
                Periode
                {{ stringDate(start_date) + " - " + stringDate(end_date) }}
              </h4>
            </div>
            <div class="flex items-center">
              <button
                @click="resetFilter"
                class="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-semibold text-white rounded-md text-sm mr-2 focus:outline-none"
              >
                Reset Filter
              </button>
              <zselect
                class="mr-2 -mt-1 w-40"
                v-model="filterMonthly"
                :data="monthOptions"
                placeholder="Pilih Bulan"
              >
              </zselect>
              <zautocomplete
                v-if="profileData.type_user === 'Super Admin'"
                class="-mt-1 w-40"
                v-model="branchSelected"
                :data="branchOptions"
                placeholder="Pilih Cabang"
              >
              </zautocomplete>
            </div>
          </div>
          <div class="flex item-center space-x-4 mt-5">
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Bulanan</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp{{
                  formatPrice(total_omzet_by_month ? total_omzet_by_month : 0)
                }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp{{
                  formatPrice(
                    total_omzet_this_month ? total_omzet_this_month : 0
                  )
                }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Hari Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp{{ formatPrice(total_omzet_today ? total_omzet_today : 0) }}
              </h1>
            </div>
          </div>
          <div class="flex item-center space-x-4 mt-5">
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Order Hari Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_order_today }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Order Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_order_this_month }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Berat Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_weight_this_month.toFixed(2) }}kg
              </h1>
            </div>
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Order Domestik
            </h1>
            <line-chart
              v-if="loaded"
              :chartdata="order_statistics"
              :options="options"
            />
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Transaksi Admin Domestik
            </h1>
            <bar-chart
              v-if="load"
              :chartData="transactions_admin"
              :options="options"
            />
          </div>
        </div>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import zselect from "@/components/zselect";
import zautocomplete from "@/components/zautocomplete";
import zloading from "@/components/zloading";
import LineChart from "@/components/zlinechart";
import BarChart from "../../components/BarChart.vue";

import { reactive, computed } from "@vue/composition-api";
import { useBranches } from "@/composables/master/useMaster";
import {
  useOmzetDomestik,
  useDomestikStatistics,
  useOrderDomestik,
  useWeightDomestik,
  useOrderTransactionsDomestik,
} from "@/composables/report/useReport";

/* Helpers tanggal (di luar setup supaya tidak re-create tiap render). */
function fmt(date) {
  const d = new Date(date);
  let m = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const y = d.getFullYear();
  if (m.length < 2) m = "0" + m;
  if (day.length < 2) day = "0" + day;
  return [y, m, day].join("-");
}
function readProfile() {
  try {
    return JSON.parse(window.localStorage.getItem("data-profile-jaskipin"));
  } catch (_) {
    return null;
  }
}
/* Branch param:
 * - Super Admin / Supervisor → branchSelected.value (dropdown)
 * - role lain               → kunci ke profile.branch._id (tidak boleh
 *   melihat data cabang lain). */
function resolveBranch(profile, branchSelected) {
  if (!profile) return undefined;
  const t = profile.type_user;
  if (t === "Super Admin" || t === "Supervisor") {
    return branchSelected && branchSelected.value
      ? branchSelected.value
      : undefined;
  }
  return profile.branch && profile.branch._id;
}

export default {
  components: {
    layouts,
    zselect,
    zautocomplete,
    LineChart,
    zloading,
    BarChart,
  },
  setup() {
    /* Master branch via TanStack Query — cache 1 jam, dedupe global. */
    const { data: branchesData } = useBranches();

    /* UI state — filterMonthly & branchSelected drive reactive params di bawah. */
    const filterState = reactive({
      filterMonthly: "",
      branchSelected: "",
      /* start_date/end_date dipakai untuk chart statistik dan ditampilkan di header. */
      start_date: "",
      end_date: "",
    });

    /* Params untuk "Bulan Ini" — selalu first/last day of current month. */
    const paramsThisMonth = computed(() => {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return {
        start_date: fmt(first),
        end_date: fmt(last),
        branch: resolveBranch(readProfile(), filterState.branchSelected),
      };
    });

    /* Params untuk "Hari Ini" */
    const paramsToday = computed(() => {
      const today = fmt(new Date());
      return {
        start_date: today,
        end_date: today,
        branch: resolveBranch(readProfile(), filterState.branchSelected),
      };
    });

    /* Params untuk "Bulan dipilih" (filterMonthly). */
    const paramsByMonth = computed(() => {
      if (!filterState.filterMonthly || filterState.filterMonthly === "") {
        return null;
      }
      const now = new Date();
      const v = filterState.filterMonthly.value;
      const first = new Date(now.getFullYear(), v, 1);
      const last = new Date(now.getFullYear(), parseInt(v + 1), 0);
      const profile = readProfile();
      const base = {
        start_date: fmt(first),
        end_date: fmt(last),
      };
      if (profile && profile.type_user === "Master Agen") {
        base.master_agen = profile.id;
        base.input_by = profile.id;
      }
      base.branch = resolveBranch(profile, filterState.branchSelected);
      return base;
    });

    /* Params chart statistik order — pakai start_date/end_date custom. */
    const paramsStat = computed(() => ({
      start_date: filterState.start_date,
      end_date: filterState.end_date,
      branch: resolveBranch(readProfile(), filterState.branchSelected),
    }));

    /* ===== Queries ===== */
    const omzetThisMonthQ = useOmzetDomestik(paramsThisMonth);
    const omzetTodayQ = useOmzetDomestik(paramsToday);
    const omzetByMonthQ = useOmzetDomestik(
      computed(() => paramsByMonth.value || {}),
      { enabled: computed(() => !!paramsByMonth.value) }
    );

    const orderTodayQ = useOrderDomestik(paramsToday);
    const orderThisMonthQ = useOrderDomestik(paramsThisMonth);
    const weightThisMonthQ = useWeightDomestik(paramsThisMonth);

    const orderStatQ = useDomestikStatistics(
      paramsStat,
      {
        enabled: computed(
          () => !!filterState.start_date && !!filterState.end_date
        ),
      }
    );

    const adminTrxQ = useOrderTransactionsDomestik(paramsToday);

    return {
      branchesData,
      filterState,
      /* raw data dari query */
      omzetThisMonthData: omzetThisMonthQ.data,
      omzetTodayData: omzetTodayQ.data,
      omzetByMonthData: omzetByMonthQ.data,
      orderTodayData: orderTodayQ.data,
      orderThisMonthData: orderThisMonthQ.data,
      weightThisMonthData: weightThisMonthQ.data,
      orderStatData: orderStatQ.data,
      adminTrxData: adminTrxQ.data,
      /* loading flag agregat untuk overlay awal */
      omzetThisMonthLoading: omzetThisMonthQ.isLoading,
    };
  },
  data() {
    return {
      /* UI state lokal — tidak terkait fetching */
      filterDate: "Bulan Ini",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      monthOptions: [
        { label: "Januari", value: 0 },
        { label: "Februari", value: 1 },
        { label: "Maret", value: 2 },
        { label: "April", value: 3 },
        { label: "Mei", value: 4 },
        { label: "Juni", value: 5 },
        { label: "Juli", value: 6 },
        { label: "Agustus", value: 7 },
        { label: "September", value: 8 },
        { label: "Oktober", value: 9 },
        { label: "November", value: 10 },
        { label: "Desember", value: 11 },
      ],
    };
  },
  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin")
      );
      return profile ? profile : null;
    },
    /* v-model proxies ke filterState supaya template tidak berubah */
    start_date: {
      get() {
        return this.filterState.start_date;
      },
      set(v) {
        this.filterState.start_date = v;
      },
    },
    end_date: {
      get() {
        return this.filterState.end_date;
      },
      set(v) {
        this.filterState.end_date = v;
      },
    },
    filterMonthly: {
      get() {
        return this.filterState.filterMonthly;
      },
      set(v) {
        this.filterState.filterMonthly = v;
      },
    },
    branchSelected: {
      get() {
        return this.filterState.branchSelected;
      },
      set(v) {
        this.filterState.branchSelected = v;
      },
    },
    branchOptions() {
      const raw = this.branchesData;
      const arr = Array.isArray(raw)
        ? raw
        : raw && raw.data
        ? raw.data
        : [];
      return arr.map((item) => ({
        label: item.city_name,
        value: item.id,
      }));
    },
    /* Mappings ke nama lama yang dipakai template */
    total_omzet_this_month() {
      const arr = this._dataArray(this.omzetThisMonthData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    total_omzet_today() {
      const arr = this._dataArray(this.omzetTodayData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    total_omzet_by_month() {
      if (!this.filterState.filterMonthly) return 0;
      const arr = this._dataArray(this.omzetByMonthData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    total_order_today() {
      const arr = this._dataArray(this.orderTodayData);
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_order_this_month() {
      const arr = this._dataArray(this.orderThisMonthData);
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_weight_this_month() {
      const arr = this._dataArray(this.weightThisMonthData);
      return arr.length === 0 ? 0 : arr[0].weight;
    },
    order_statistics() {
      const arr = this._dataArray(this.orderStatData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.date),
        datasets: [
          {
            label: "Total Order Domestik",
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.1)",
            data: arr.map((item) => item.order_count),
          },
        ],
      };
    },
    transactions_admin() {
      const arr = this._dataArray(this.adminTrxData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.pengguna),
        datasets: [
          {
            label: "Total Transaksi Domestik",
            borderWidth: 1,
            borderColor: "rgba(255,99,132,1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            pointBorderColor: "#2554FF",
            data: arr.map((item) => item.total),
          },
        ],
      };
    },
    loaded() {
      return !!this.order_statistics;
    },
    load() {
      return !!this.transactions_admin;
    },
    loading() {
      /* overlay awal — sembunyikan saat first query selesai */
      return this.omzetThisMonthLoading && !this.omzetThisMonthData;
    },
  },
  created() {
    this.selectRangeDate();
  },
  methods: {
    _dataArray(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (raw.data) return Array.isArray(raw.data) ? raw.data : [];
      return [];
    },
    resetFilter() {
      this.filterDate = "Bulan Ini";
      this.filterState.start_date = "";
      this.filterState.end_date = "";
      this.filterState.filterMonthly = "";
      this.filterState.branchSelected = "";
      this.selectRangeDate();
    },
    selectRangeDate() {
      let date = new Date();
      let firstDay;
      let lastDay;

      switch (this.filterDate) {
        case "Hari Ini":
          firstDay = date;
          lastDay = date;
          break;

        case "Bulan Ini":
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;

        case "Tahun Ini":
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);
          break;

        case "7 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 7));
          lastDay = new Date();
          break;

        case "30 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 30));
          lastDay = new Date();
          break;

        default:
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;
      }

      this.filterState.start_date = this.formatDate(firstDay);
      this.filterState.end_date = this.formatDate(lastDay);
    },
    formatDate(date) {
      return fmt(date);
    },
    stringDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
  },
};
</script>

<style scoped></style>
